module.exports = __webpack_public_path__ + "officialStatic/img/pse.da331b8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pse.gif
// module id = /3f4
// module chunks = 0